import * as Dropdown from "@radix-ui/react-dropdown-menu";
import type { ReactNode } from "react";
import { cn } from "../lib/cn.ts";

export const DropdownMenu = Dropdown.Root;
export const DropdownMenuTrigger = Dropdown.Trigger;

export function DropdownMenuContent({
  children,
  align = "end",
  class: klass,
  className,
}: {
  children: ReactNode;
  align?: "start" | "center" | "end";
  /** Para el ancho, cuando el contenido es una lista y no un par de acciones. */
  class?: string;
  className?: string;
}) {
  return (
    <Dropdown.Portal>
      <Dropdown.Content
        align={align}
        sideOffset={8}
        className={cn(
          "z-[110] min-w-52 rounded-xl border border-border bg-popover p-1.5 text-popover-foreground shadow-xl",
          klass,
          className,
        )}
      >
        <div>{children}</div>
      </Dropdown.Content>
    </Dropdown.Portal>
  );
}

export function DropdownMenuItem({
  children,
  onSelect,
  className,
}: {
  children: ReactNode;
  onSelect?: () => void;
  className?: string;
}) {
  return (
    <Dropdown.Item
      onSelect={onSelect}
      className={cn(
        // Los iconos se ordenan acá y no en cada llamada: son la parte que
        // hace legible una lista de acciones —se lee el icono antes que el
        // texto— y venían con tamaños y grises distintos según el menú.
        // Atenuados con opacidad y no con un color propio, para que hereden el
        // del renglón: así el «Eliminar» sigue teniendo el icono rojo.
        "flex cursor-default select-none items-center gap-2.5 rounded-lg px-3 py-2 text-sm outline-none transition-colors",
        "[&>svg]:h-4 [&>svg]:w-4 [&>svg]:shrink-0 [&>svg]:opacity-70",
        "focus:bg-muted focus:[&>svg]:opacity-100",
        className,
      )}
    >
      {children}
    </Dropdown.Item>
  );
}

export function DropdownMenuLabel({ children }: { children: ReactNode }) {
  return (
    // Sin mayúsculas ni espaciado de encabezado: acá adentro van el nombre y el
    // correo de quien usa el panel, y todo lo que se ponga en este contenedor
    // lo heredan. `leading-snug` porque el contenido son dos o tres renglones
    // cortos apilados, no una línea.
    <Dropdown.Label className="px-3 pb-2 pt-2.5 text-xs font-medium leading-snug text-muted-foreground">
      {children}
    </Dropdown.Label>
  );
}

export function DropdownMenuSeparator() {
  return <Dropdown.Separator className="my-1 h-px bg-border" />;
}
